import React, { useState, useEffect, useContext, useRef } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { handleRedirectInternal, jsonToFormData, mapData } from '../../Product/common/components'
import { Link, useHistory } from 'react-router-dom'
import FacebookLogin from 'react-facebook-login'
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import AuthContext from '../../Product/context/auth/authContext'
import axios from 'axios'
import { swapCountry } from '../commonFunctions'
import Captch from '../../Themes/MultiAuction/Registration/Captch'
import Popup from '../../Product/components/organisms/Popup'
import AlertContext from '../../Product/context/alert/alertContext'
import jsonp from 'jsonp'
import queryString from 'query-string'
import sha256 from 'crypto'
import pluginContext from '../../Product/context/plugin/pluginContext'
import productContext from '../../Product/context/product/productContext'
import { useMediaQuery } from 'react-responsive'
import jwt_decode from 'jwt-decode'
import { Step, StepButton, Stepper } from '@material-ui/core'
import AddCardForm from './StripeIntegration/AddCardForm'
import StripeCustomerContext from '../../Product/context/stripe/customer/customerContext'
import StripeCardContext from '../../Product/context/stripe/card/cardContext'
import { useTranslation } from 'react-i18next'
import UserContext from '../../Product/context/user/userContext'
import { NavLink } from 'react-router-dom/cjs/react-router-dom'

function getSteps() {
    return ['', '', '', '']
}

function SignupStepperFunction({
    multipleUserRole,
    title,
    subTitle,
    regpro,
    defaultCountryCode,
    termsCondition,
    privacyPolicy,
    needCountrybox,
    captcha,
    phone_country_code_must,
    autoComplete,
}) {
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const userContext = useContext(UserContext)
    const { getAlldynamic, dynamicproducts, validateReferralCode } = useContext(productContext)
    const { editPhone } = userContext
    const [fields, setFields] = useState({})
    const [saveClicked, setSaveClicked] = useState(false)
    let searchParams = new URLSearchParams(window.location.search)
    let {
        register,
        responseStatus,
        logout,
        isAuthenticated,
        user,
        verifyemailandsmscode,
        clearResponse,
        login,
    } = authContext
    const {
        customer_details,
        createStripeCustomer,
        createCustomer,
        getStripeCustomer,
        addCustomerProfile,
        updateCustomerDefaultCard,
        responseStatus: responseStatusStripeCustomer,
    } = useContext(StripeCustomerContext)
    const {
        get_all_card_details,
        createStripeCard,
        createCard,
        createStripeCardWithCustomer,
        deleteStripeCard,
        deleteCard,
        updateStripeCard,
        responseStatus: stripeCardResponse,
        clearResponse: stripeCardClearResponse,
    } = useContext(StripeCardContext)
    const { createReferral, securityScanner, buyerNotification } = useContext(pluginContext)
    const { setAlert } = useContext(AlertContext)
    const [countryList, setCountryList] = useState([])
    const [stateList, setStateList] = useState([])
    const [terms_condition, setTermscondition] = useState(false)
    const [reg_req_data, setRegistrationdata] = useState({})
    const [otppopup, setOtppopup] = useState(false)
    const [emailotp, setEmailotp] = useState('')
    const [mobileotp, setMobileotp] = useState('')
    const [mobileVerification, setMobileVerification] = useState(false)
    const [loading, setLoading] = useState(false)
    const [othersField, setOtherField] = useState(false)
    const [step, setStep] = useState(0)
    const [activeStep, setActiveStep] = React.useState(0)
    const [completed, setCompleted] = React.useState({})
    const isUS =
        (navigator.language.includes('-') ? navigator.language.split('-')[1] : 'US') === 'US'
    const [skipValidation, setSkipValidation] = useState(false)
    const steps = getSteps()
    const { t } = useTranslation()
    const [customerId, setCustomerId] = useState('')
    const [customerUserId, setCustomerUserId] = useState('')
    const validationArray = Yup.object().shape({
        first_name:
            global.storeConfigration?.signup_page_changes?.value !== '1'
                ? Yup.string()
                      .trim()
                      .matches(
                          /^[a-zA-Z\s]*$/g,
                          'The special characters and numbers are not allowed!',
                      )
                      .max(20, 'Maximum 20 characters')
                      .required('Required')
                : undefined,
        last_name:
            global.storeConfigration?.signup_page_changes?.value !== '1'
                ? Yup.string()
                      .trim()
                      .matches(
                          /^[a-zA-Z\s]*$/g,
                          'The special characters and numbers are not allowed!',
                      )
                      .max(20, 'Maximum 20 characters')
                      .required('Required')
                : undefined,
        email: Yup.string()
            .email('Invalid email format')
            .max(250, 'Maximum 250 characters')
            .required('Required'),
        phone: phone_country_code_must
            ? Yup.string()
                  .trim()
                  .matches(/^\+/, 'Please enter country code')
                  .matches(/^[+]?[0-9]+$/, 'Only numbers are allowed')
                  .min(12, 'Invalid Number!')
                  .max(16, 'Maximum 14 characters')
                  .required('Required')
            : global?.storeConfigration?.ten_digit_phone_number?.value == 1
            ? Yup.string()
                  .trim()
                  .matches(/^[+]?[0-9]+$/, 'Only numbers are allowed')
                  .min(10, 'Invalid!')
                  .max(10, 'Invalid!')
                  .required('Required')
            : Yup.string()
                  .trim()
                  .matches(/^[+]?[0-9]+$/, 'Only numbers are allowed')
                  .min(10, 'Invalid!')
                  .max(15, 'Maximum 14 characters')
                  .required('Required'),
        password:
            global?.storeConfigration?.strong_password?.value == 1
                ? Yup.string()
                      .matches(/^\S*$/, 'White Spaces Not Allowed')
                      //   .matches(
                      //       /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$&*])(?=.*\d)[A-Za-z\d]/,
                      //       'Must contain One Uppercase, One Lowercase, One Number,One Special Characters',
                      //   )
                      .matches(/^(?=.*[a-z])/, 'Must contain one lowercase character')
                      .matches(/^(?=.*[A-Z])/, 'Must contain one uppercase character')
                      .matches(/^(?=.*[0-9])/, 'Must contain one number character')
                      .matches(
                          /^(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`])/,
                          'Must contain one special case character',
                      )
                      .min(8, 'Minimum 8 characters')
                      .required('Required')
                : Yup.string()
                      .matches(/^\S*$/, 'White Spaces Not Allowed')
                      .min(8, 'Minimum 8 characters')
                      .required('Required'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('password')], 'Passwords not match')
            .required('Required'),
        country:
            global.storeConfigration?.signup_page_changes?.value !== '1'
                ? Yup.string().trim().required('Required')
                : undefined,
        state:
            global.storeConfigration?.signup_page_changes?.value !== '1'
                ? Yup.string().trim().required('Required')
                : undefined,
        address1:
            global.storeConfigration?.signup_page_changes?.value !== '1'
                ? Yup.string()
                      .trim()
                      // .matches(/^[0-9a-zA-Z- ,.#()]*$/g, 'Special characters not allowed')
                      .max(250, 'Maximum 250 characters')
                      .required('Required')
                : undefined,
        address2:
            global.storeConfigration?.signup_page_changes?.value !== '1'
                ? Yup.string()
                      .trim()
                      // .matches(/^[0-9a-zA-Z- ,.#()]*$/g, 'Special characters not allowed')
                      .max(250, 'Maximum 250 characters')
                : undefined,
        city:
            global.storeConfigration?.signup_page_changes?.value !== '1'
                ? Yup.string()
                      .trim()
                      .matches(/^[_A-zA-Z]*((-|\s)*[_A-zA-Z])*$/g, 'Only Alphabets are allowed')
                      .required('Required')
                : undefined,
        zip:
            global.storeConfigration?.signup_page_changes?.value !== '1'
                ? Yup.string()
                      .when([], {
                          is: () => formik?.values.country != 156,
                          then: Yup.string().required('Required!'),
                          otherwise: Yup.string().notRequired(),
                      })
                      .matches(/^[0-9a-zA-Z- ,.#()]*$/g, 'Special characters not allowed')
                      .min(5, 'Minimum 5 characters')
                      .max(7, 'Maximum 7 characters')
                : undefined,
        captch:
            global.storeConfigration?.signup_page_changes?.value !== '1'
                ? captcha
                    ? Yup.boolean().oneOf([true]).required('Required')
                    : Yup.string()
                : undefined,
        termCheck:
            global?.storeConfigration?.terms_con_must_reg?.value == 1 ||
            global?.storeConfigration?.remove_signup_terms?.value == 1
                ? ''
                : Yup.boolean()
                      .oneOf([true], 'Please accept Terms and Conditions')
                      .required('Please accept Terms and Conditions'),
        referral: global.storeDetails?.theme == 20 ? Yup.string().required('Required') : undefined,
        card_profileid:
            global.storeConfigration?.signup_page_changes?.value !== '1'
                ? Yup.string().when('role', {
                      is: '1' || 1,
                      then: Yup.string().trim().required('Required'),
                  })
                : undefined,
        heard_from: othersField ? Yup.string().trim().required('Required') : undefined,
    })

    const validationSchemas = [
        Yup.object().shape({
            first_name:
                global.storeConfigration?.signup_page_changes?.value !== '1'
                    ? Yup.string()
                          .trim()
                          .matches(
                              /^[a-zA-Z\s]*$/g,
                              'The special characters and numbers are not allowed!',
                          )
                          .max(20, 'Maximum 20 characters')
                          .required('Required')
                    : undefined,
            last_name:
                global.storeConfigration?.signup_page_changes?.value !== '1'
                    ? Yup.string()
                          .trim()
                          .matches(
                              /^[a-zA-Z\s]*$/g,
                              'The special characters and numbers are not allowed!',
                          )
                          .max(20, 'Maximum 20 characters')
                          .required('Required')
                    : undefined,
            email: Yup.string()
                .email('Invalid email format')
                .max(250, 'Maximum 250 characters')
                .required('Required'),

            password:
                global?.storeConfigration?.strong_password?.value == 1
                    ? Yup.string()
                          .matches(/^\S*$/, 'White Spaces Not Allowed')
                          //   .matches(
                          //       /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$&*])(?=.*\d)[A-Za-z\d]/,
                          //       'Must contain One Uppercase, One Lowercase, One Number,One Special Characters',
                          //   )
                          .matches(/^(?=.*[a-z])/, 'Must contain one lowercase character')
                          .matches(/^(?=.*[A-Z])/, 'Must contain one uppercase character')
                          .matches(/^(?=.*[0-9])/, 'Must contain one number character')
                          .matches(
                              /^(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`])/,
                              'Must contain one special case character',
                          )
                          .min(8, 'Minimum 8 characters')
                          .required('Required')
                    : Yup.string()
                          .matches(/^\S*$/, 'White Spaces Not Allowed')
                          .min(8, 'Minimum 8 characters')
                          .required('Required'),
        }),
        Yup.object().shape({
            verification_code: Yup.string()
                .required('Verification code is required')
                .matches(/^\d{6}$/, 'Verification code must be exactly 6 digits'),
        }),
        !skipValidation
            ? mobileVerification
                ? Yup.object().shape({
                      verification_mobile_code: Yup.string()
                          .required('Verification code is required')
                          .matches(/^\d{4}$/, 'Verification code must be exactly 4 digits'),
                  })
                : Yup.object().shape({
                      phone: phone_country_code_must
                          ? Yup.string()
                                .trim()
                                .matches(/^\+/, 'Please enter country code')
                                .matches(/^[+]?[0-9]+$/, 'Only numbers are allowed')
                                .min(12, 'Invalid Number!')
                                .max(16, 'Maximum 14 characters')
                                .required('Required')
                          : global?.storeConfigration?.ten_digit_phone_number?.value == 1
                          ? Yup.string()
                                .trim()
                                .matches(/^[+]?[0-9]+$/, 'Only numbers are allowed')
                                .min(10, 'Invalid!')
                                .max(10, 'Invalid!')
                                .required('Required')
                          : Yup.string()
                                .trim()
                                .matches(/^[+]?[0-9]+$/, 'Only numbers are allowed')
                                .min(10, 'Invalid!')
                                .max(15, 'Maximum 14 characters')
                                .required('Required'),
                  })
            : Yup.object().shape({
                  phone: Yup.string().optional(),
              }),
        Yup.object(),
    ]

    const inputRefs = useRef([])

    const handleStep = (index) => {
        if (activeStep == 1 && index == 0) {
            setActiveStep(index)
            window.scrollTo(0, 0)
        }
        // else if (object.keys(reg_req_data).length !== 0 && index == 1) {
        //     setActiveStep(index)
        //     window.scrollTo(0, 0)
        // }
    }

    const isDesktop = useMediaQuery({
        query: '(min-width: 600px)',
    })

    const requiredfields = {
        role: multipleUserRole ? 1 : 0,
        first_name: '',
        last_name: '',
        email: '',
        phone_number_new: '',
        phone:
            global?.storeConfigration?.ten_digit_phone_number?.value == 1
                ? ''
                : global?.storeConfigration?.default_phone_code?.value
                ? global?.storeConfigration?.default_phone_code?.value
                : '+1',
        password: '',
        confirmPassword: '',
        country: defaultCountryCode ? defaultCountryCode : '',
        state: '',
        city: '',
        address1: '',
        address2: '',
        tempAddress: '',
        zip: '',
        captch: false,
        termCheck: 0,
        subscribe: Intl.DateTimeFormat().resolvedOptions().timeZone.startsWith('America/')
            ? true
            : false,
        card_profileid: '',
        community: 'auction_io',
        is_auctionio: 1,
        status:
            global.storeConfigration?.need_reg_verification_email?.value == 1 ||
            global.storeConfigration?.need_admin_verification?.value == 1
                ? 'unverified'
                : '',
        redirectURL:
            global.storeConfigration?.need_reg_verification_email?.value == 1
                ? `${window.location.href.split('/sign-up')[0]}/activateaccount`
                : '',
        referral: '',
        account_id:
            global.storeConfigration?.enable_payment_gateway_register?.value == 1
                ? process.env.REACT_APP_AUCTIONPAYID
                : undefined,
        description:
            global.storeConfigration?.enable_payment_gateway_register?.value == 1
                ? 'Registration Customer Creation'
                : undefined,
        register_to_payment_gateway:
            global.storeConfigration?.enable_payment_gateway_register?.value,
        buyer_document_2: [],
        heard_from: '',
        verification_code: '',
        verification_mobile_code: '',
    }

    const formik = useFormik({
        initialValues: fields.dynamic_fields
            ? { ...requiredfields, ...fields.dynamic_fields }
            : requiredfields,
        validationSchema: validationSchemas[activeStep],
        enableReinitialize: true,
        onSubmit: async (val) => {
            let values = { ...val }
            values.zipcode = values.zip
            setLoading(true)
            if (dynamicproducts.length > 0) {
                if (dynamicproducts[0].form_json.includes('[{')) {
                    var dynamic_data = JSON.parse(dynamicproducts[0].form_json),
                        final_dynamic_data = []
                    dynamic_data.map((va) => {
                        final_dynamic_data.push({ ...va, ...{ user_value: values[va.name] } })
                    })
                    values.dynamic_fields = JSON.stringify(final_dynamic_data)
                }
            }
            var tax_exempt =
                typeof global.storeConfigration?.remove_state_from_tax_exempt?.value === 'string'
                    ? global.storeConfigration?.remove_state_from_tax_exempt?.value
                    : ''
            //console.log(tax_exempt)
            if (tax_exempt) {
                var find_state = tax_exempt.split(',').find((val) => val === values.state)
                if (!find_state) {
                    values.tax_excempt = 1
                }
            }
            if (global.storeConfigration?.referral_value?.value) {
                values.heard_from =
                    values.referral == 1
                        ? 'Friend Referral'
                        : values.referral == 2
                        ? 'Email'
                        : values.referral == 3
                        ? 'Auction.io'
                        : values.referral == 4
                        ? 'Google'
                        : values.referral == 5
                        ? 'Facebook'
                        : values.referral == 6
                        ? 'Instagram'
                        : values.referral == 7
                        ? 'Auction Event'
                        : values.referral == 8
                        ? 'Yelp'
                        : `Don't Want to Disclose`
            }

            values.username = values.first_name + values.last_name
            if (global?.storeConfigration?.disable_phone_country_code?.value == 1) {
                values.phone = `+1${values.phone}`
            }

            if (activeStep == 0) {
                // if (global?.storeConfigration?.terms_con_must_reg?.value == 1) {
                //     setRegistrationdata(values)
                //     setTermscondition(true)
                // } else
                if (
                    (global?.storeConfigration?.otp_verification_mobile_number?.value == 1 ||
                        global?.storeConfigration?.otp_verification_email?.value == 1) &&
                    activeStep == 0
                ) {
                    if (global?.storeConfigration?.otp_verification_email?.value == 1) {
                        values.email_verification = 1
                        values.six_digit = 1
                        values.exclude_phone = 1
                    }
                    // if (global?.storeConfigration?.otp_verification_mobile_number?.value == 1) {
                    //     values.mobile_varification = 1
                    //     values.userPhone = values.phone
                    // }
                    if (values.referusercode) {
                        const res = await validateReferralCode({
                            site_id: global?.storeDetails?.site_id,
                            referusercode: values.referusercode,
                        })
                        if (res.success == 'no') {
                            setAlert('Invalid Code!', 'error')
                            setLoading(false)
                            return
                        }
                    }
                    verifyemailandsmscode(values)
                    setRegistrationdata(values)
                    // setActiveStep((prev) => prev + 1)
                    // setLoading(false)
                    return
                    //setOtppopup(true)
                }
            } else if (activeStep == 1) {
                await call_verify_and_register('email')
                return
            } else if (activeStep == 2) {
                if (skipValidation) {
                    setActiveStep((prev) => prev + 1)
                    window.scrollTo(0, 0)
                    setLoading(false)
                    return
                } else if (mobileVerification) {
                    await call_verify_and_register('sms')
                    return
                } else if (
                    global?.storeConfigration?.otp_verification_mobile_number?.value == 1 ||
                    global?.storeConfigration?.otp_verification_email?.value == 1
                ) {
                    //    if (global?.storeConfigration?.otp_verification_email?.value == 1) {
                    //        values.email_verification = 1
                    //        values.six_digit = 1
                    //        values.exclude_phone = 1
                    //    }
                    if (global?.storeConfigration?.otp_verification_mobile_number?.value == 1) {
                        values.mobile_varification = 1
                        values.exclude_email = 1
                        values.userPhone = values.phone
                    }
                    verifyemailandsmscode(values)
                    setRegistrationdata(values)
                    // setActiveStep((prev) => prev + 1)
                    // setLoading(false)
                    return
                    //setOtppopup(true)
                } else {
                }
            } else if (activeStep == 3) {
                setActiveStep((prev) => prev + 1)
                window.scrollTo(0, 0)
                return
            } else if (activeStep == 4) {
                setAlert('Hey you have registered !', 'success')
                login({
                    is_auctionio: 1,
                    username: values.email,
                    password: values.password,
                    community: 'auction_io',
                })
                const project_id = localStorage.getItem('routeTo')
                if (project_id) {
                    handleRedirectInternal(history, `product/${project_id}`)
                } else {
                    handleRedirectInternal(history, '')
                }
                return
            } else {
                setActiveStep((prev) => prev + 1)
                window.scrollTo(0, 0)
                setLoading(false)
                return
            }

            if (global.storeConfigration?.display_register_doument_field?.value == 1) {
                let sendData = jsonToFormData(values)
                register(sendData)
            } else {
                register(values)
            }
        },
    })

    const responseFacebook = (response) => {
        const params = {
            first_name: response.name,
            email: response.email,
            fb_id: response.accessToken,
            fb_json: response.id,
            password: response.id,
            community: 'auction_io',
            is_auctionio: 1,
            role: 0,
        }
        register(params)
    }

    const responseGoogle = (response) => {
        const decode = jwt_decode(response.credential)
        console.log('decode signup', decode)
        const params = {
            first_name: decode.name,
            email: decode.email,
            li_id: response,
            li_json: decode.jti,
            password: decode.sub,
            community: 'auction_io',
            is_auctionio: 1,
            role: 0,
        }
        register(params)
    }

    var data = []

    data.push(
        {
            label: 'Email' + '*',
            name: 'email',
            type: 'email',
            placeholder: 'Enter your email address',
            class: 'col-12 col-sm-12',
            autoFocus: true,
        },
        {
            label: 'First Name' + '*',
            name: 'first_name',
            type: 'text',
            placeholder: 'Enter your first name',
            class:
                global.storeConfigration?.signup_page_changes?.value !== '1'
                    ? 'col-12 col-sm-6'
                    : 'd-none',
        },
        {
            label: 'Last Name' + '*',
            name: 'last_name',
            type: 'text',
            placeholder: 'Enter your last name',
            class:
                global.storeConfigration?.signup_page_changes?.value !== '1'
                    ? 'col-12 col-sm-6'
                    : 'd-none',
        },
        {
            label: 'Password' + '*',
            name: 'password',
            type: 'password',
            placeholder: 'Enter your password',
            class: 'col-12 col-sm-12',
            disablePaste: true,
            helperText: 'Must include at least 8 characters, a number, and a symbol',
            autoComplete: autoComplete ? (autoComplete == 'off' ? 'off' : 1) : 0,
        },
        {
            label: 'Referral Code',
            name: 'referusercode',
            type: 'text',
            placeholder: 'Enter referral code',
            class: 'col-12 col-sm-12',
        },
        // {
        //     label: 'Mobile number' + '*',
        //     name: 'phone',
        //     type: 'text',
        //     placeholder: 'Enter your mobile number',
        //     class: 'col-12 col-sm-6',
        //     countryCodeEditable: false,
        //     startAdornment:
        //         global?.storeConfigration?.disable_phone_country_code?.value == 1 ? '+1' : '',
        // },
        // {
        //     label: 'Confirm password' + '*',
        //     name: 'confirmPassword',
        //     type: 'password',
        //     placeholder: 'Re enter your password',
        //     class: 'col-12 col-sm-6',
        //     disablePaste: true,
        // },
        // {
        //     label: 'Address Line 1' + '*',
        //     name: 'address1',
        //     type: global.storeConfigration?.map_input?.value == '1' ? 'mapInput' : 'text',
        //     placeholder: 'Enter your address line 1',
        //     class:
        //         global.storeConfigration?.signup_page_changes?.value !== '1'
        //             ? 'col-12 col-sm-6 mb-4'
        //             : 'd-none',
        // },
        // {
        //     label: 'Address Line 2',
        //     name: 'address2',
        //     type: 'text',
        //     placeholder: 'Enter your address line 2',
        //     class:
        //         global.storeConfigration?.signup_page_changes?.value !== '1'
        //             ? 'col-12 col-sm-6'
        //             : 'd-none',
        // },
    )

    // const emailField = data.find((item) => item.name === 'email')

    // if (
    //     (defaultCountryCode === undefined || defaultCountryCode == '' || needCountrybox == 1) &&
    //     global.storeConfigration?.signup_page_changes?.value !== '1'
    // ) {
    //     data.push({
    //         label: 'Country' + '*',
    //         placeholder: 'Select your country',
    //         class:
    //             global.storeConfigration?.signup_page_changes?.value !== '1'
    //                 ? 'col-12 col-sm-6'
    //                 : 'd-none',
    //         type: 'select',
    //         options: swapCountry(countryList).map((country) => {
    //             let busCategoryChanged = {}
    //             busCategoryChanged.show = country.name
    //             busCategoryChanged.value = country.location_id
    //             return busCategoryChanged
    //         }),
    //         name: 'country',
    //     })
    // }

    // const referralOptions = [
    //     { id: 1, description: 'Friend Referral' },
    //     { id: 2, description: 'Email' },
    //     { id: 3, description: 'Auction.io' },
    //     { id: 4, description: 'Google' },
    //     { id: 5, description: 'Facebook' },
    //     { id: 6, description: 'Instagram' },
    //     { id: 7, description: 'Auction Event' },
    //     { id: 8, description: 'Yelp' },
    //     { id: 9, description: `Don't Want to Disclose` },
    //     { id: 10, description: 'Others' },
    // ]
    // const referralOptionsBidAuctionDepot = [
    //     { id: 'Social Media', description: 'Social Media (Facebook, Instagram, LinkedIn, etc.)' },
    //     { id: 'Google', description: 'Google' },
    //     { id: 'Personal referral', description: 'Word of Mouth / Referral from Friend or Family' },
    //     {
    //         id: 'Online Advertisement',
    //         description: 'Online Advertisement (Google Ads, Social Media Ads)',
    //     },
    //     { id: 'Email Newsletter or Promotion', description: 'Email Newsletter or Promotion' },
    //     { id: 'Direct Mail or Flyer', description: 'Direct Mail or Flyer' },
    //     { id: 'Billboard or Outdoor Ad', description: 'Billboard or Outdoor Ad' },
    //     { id: 'Influencer', description: 'Influencer' },
    //     { id: 'Other', description: `Other` },
    // ]

    // data.push(
    //     {
    //         label: defaultCountryCode == '38' ? 'Province' + '*' : 'State' + '*',
    //         placeholder: defaultCountryCode == '38' ? 'Select your province' : 'Select your state',
    //         class:
    //             global.storeConfigration?.signup_page_changes?.value !== '1'
    //                 ? 'col-12 col-sm-6'
    //                 : 'd-none',
    //         type: 'select',
    //         options: stateList.map((buscat) => {
    //             let busCategoryChanged = {}
    //             busCategoryChanged.show = buscat.name
    //             busCategoryChanged.value = buscat.name
    //             return busCategoryChanged
    //         }),
    //         name: 'state',
    //     },
    //     {
    //         label: 'City' + '*',
    //         name: 'city',
    //         type: 'text',
    //         placeholder: 'Enter your city',
    //         class:
    //             global.storeConfigration?.signup_page_changes?.value !== '1'
    //                 ? 'col-12 col-sm-6'
    //                 : 'd-none',
    //     },
    //     {
    //         label: defaultCountryCode == '38' ? 'Postal Code' + '*' : 'Zip code' + '*',
    //         placeholder:
    //             defaultCountryCode == '38' ? 'Enter your postal code' : 'Enter your zip code',
    //         class:
    //             global.storeConfigration?.signup_page_changes?.value !== '1'
    //                 ? `col-12 col-sm-6 ${formik?.values?.country == 156 ? 'd-none' : ''}`
    //                 : 'd-none',
    //         type: 'text',
    //         name: 'zip',
    //     },
    //     {
    //         type: 'uploadDropZone',
    //         formik: formik,
    //         name: 'buyer_document_2',
    //         titleText: "Driver's License Upload",
    //         innerText: (
    //             <div className="text-center">
    //                 <span className="material-icons">note_add</span>
    //                 <br />
    //                 <p className="mb-2 mt-2">
    //                     <b>
    //                         <span>Upload Driver's License Document</span>
    //                     </b>
    //                 </p>
    //                 <span>Recommended format: .docx, .doc, .pdf, .jpg, .jpeg</span>
    //             </div>
    //         ),
    //         class:
    //             global.storeConfigration?.signup_page_changes?.value !== '1'
    //                 ? `col-12 col-sm-12 ${
    //                       global.storeConfigration?.display_register_doument_field?.value == 1
    //                           ? ''
    //                           : 'd-none'
    //                   }`
    //                 : 'd-none',
    //         folder: '',
    //         multiple: true,
    //         accept: [
    //             'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    //             'application/msword',
    //             'application/pdf',
    //             'image/jpeg',
    //         ],
    //         compressImages: false,
    //     },
    //     {
    //         title: 'How Did You Find Us?',
    //         placeholder:
    //             global.storeConfigration?.signup_page_changes?.value !== '1'
    //                 ? ''
    //                 : 'How Did You Find Us?',
    //         type: global.storeConfigration?.signup_page_changes?.value !== '1' ? 'radio' : 'select',
    //         name: 'referral',
    //         int: 1,
    //         class:
    //             global.storeConfigration?.signup_page_changes?.value !== '1'
    //                 ? global.storeConfigration?.referral_value?.value == 1
    //                     ? 'col-md-12 hrFrm'
    //                     : 'd-none'
    //                 : 'col-md-12 hrFrm',
    //         customLabel: true,
    //         options:
    //             global.storeConfigration?.signup_page_changes?.value !== '1'
    //                 ? []
    //                 : referralOptions.map((option) => {
    //                       let busCategoryChanged = {}
    //                       busCategoryChanged.show = option.description
    //                       busCategoryChanged.value = option.id
    //                       return busCategoryChanged
    //                   }),
    //         item: referralOptions.map((option) => {
    //             let busCategoryChanged = {}
    //             busCategoryChanged.show = option.description
    //             busCategoryChanged.value = option.id
    //             return busCategoryChanged
    //         }),
    //     },
    //     {
    //         title: 'How Did You Hear About Us?',
    //         placeholder: 'How Did You Hear About Us?',
    //         type: 'select',
    //         name: 'referral',
    //         int: 1,
    //         class: global.storeDetails?.theme == 20 ? 'col-md-12 hrFrm' : 'd-none',
    //         customLabel: true,
    //         options: referralOptionsBidAuctionDepot.map((option) => {
    //             let busCategoryChanged = {}
    //             busCategoryChanged.show = option.description
    //             busCategoryChanged.value = option.id
    //             return busCategoryChanged
    //         }),
    //     },
    //     {
    //         label: 'Source' + '*',
    //         name: 'heard_from',
    //         type: 'text',
    //         placeholder: 'Enter source name',
    //         class: othersField ? 'col-md-12 hrFrm' : 'd-none',
    //         autoFocus: true,
    //     },
    //     {
    //         label: [
    //             'I agree to the',

    //             termsCondition ? (
    //                 <a
    //                     target="_blank"
    //                     rel="noreferrer"
    //                     href={termsCondition}
    //                     key="termsOfSerice"
    //                     style={{ textDecoration: 'underline' }}
    //                 >
    //                     Terms and Conditions
    //                 </a>
    //             ) : privacyPolicy ? (
    //                 <>
    //                     <Link
    //                         target="_blank"
    //                         rel="noreferrer"
    //                         to={'/termsOfService'}
    //                         key="termsOfSerice"
    //                         style={{ textDecoration: 'underline' }}
    //                     >
    //                         Terms and Conditions
    //                     </Link>
    //                     &nbsp;and
    //                     <Link
    //                         target="_blank"
    //                         rel="noreferrer"
    //                         to={'/privacy_policy'}
    //                         key="privacy_policy"
    //                         style={{ textDecoration: 'underline' }}
    //                     >
    //                         Privacy Policy
    //                     </Link>
    //                 </>
    //             ) : (
    //                 <Link
    //                     target="_blank"
    //                     rel="noreferrer"
    //                     to={'/termsOfService'}
    //                     key="termsOfSerice"
    //                     style={{ textDecoration: 'underline' }}
    //                 >
    //                     Terms and Conditions
    //                 </Link>
    //             ),
    //         ],
    //         name: 'termCheck',
    //         type: 'checkbox',
    //         class:
    //             global?.storeConfigration?.terms_con_must_reg?.value == 1 ||
    //             global?.storeConfigration?.remove_signup_terms?.value == 1
    //                 ? 'd-none'
    //                 : 'col-md-12',
    //     },
    //     {
    //         label: ['Send me product updates and news'],
    //         name: 'subscribe',
    //         type: 'checkbox',
    //         class:
    //             global.storeConfigration?.subscribe_code?.value != undefined &&
    //             global.storeConfigration?.subscribe_code?.value != ''
    //                 ? 'col-5'
    //                 : 'd-none',
    //     },
    // )

    const registerInfo = {
        formik: formik,
        data,
    }

    const promotionData = {
        formik: formik,
        data: [
            {
                label: [
                    'I would like to receive electronic marketing communication from Retail Rush',
                ],
                name: 'subscribe',
                type: 'checkbox',
                class: 'col-12 promotionClass',
                style: {
                    marginBottom: '5px',
                    marginLeft: '-10px',
                },
            },
        ],
    }

    const verifyPhoneInfo = {
        formik: formik,
        data: [
            {
                label: 'Phone Number',
                name: 'phone',
                type: 'text',
                placeholder: 'Phone Number',
                class: 'col-12 col-sm-6',
                countryCodeEditable: false,
                startAdornment:
                    global?.storeConfigration?.disable_phone_country_code?.value == 1 ? '+1' : '',
            },
        ],
    }

    const getLocationData = (type) => {
        var body = {
            countryCode: type == 1 ? 224 : formik.values.country,
        }
        return axios
            .post(`${process.env.REACT_APP_URL}fetchLocation`, body)
            .then(function (response) {
                if (response.data.success) {
                    setStateList(response.data.state)
                    setCountryList(response.data.country)
                    console.log(response.data, 'responseCity')
                }
            })
            .catch(function (error) {
                console.error(error)
            })
    }

    const call_verify_and_register = (type) => {
        try {
            if (type == 'email') {
                if (emailotp == formik.values.verification_code) {
                    register({ ...reg_req_data, retail: 1 })
                } else {
                    setAlert('Entered Email Code Was Invalid', 'error')
                    setLoading(false)
                }
            } else if (type == 'sms') {
                if (mobileotp == formik.values.verification_mobile_code) {
                    console.log('came inside verification --')
                    editPhone({
                        userid: formik.values.userid,
                        phone: formik.values.phone,
                        retail: 1,
                    })
                    setActiveStep((prev) => prev + 1)
                    window.scrollTo(0, 0)
                } else {
                    setAlert('Entered Sms Code Was Invalid', 'error')
                    setLoading(false)
                }
            } else {
                // if (mobileotp != verifyformik.values.smscode) {
                //     setAlert('Entered Sms Code Was Invalid', 'error')
                // }
                if (emailotp != formik.values.verification_code) {
                    setAlert('Entered Email Code Was Invalid', 'error')
                }
            }
        } catch (err) {
            console.log('call_verify_and_register------', err)
        }
    }

    const creditCardYearOptions = []

    let date = new Date()
    let currentYear = date.getFullYear()
    let upToYear = parseInt(currentYear) + 25
    for (let year = parseInt(currentYear); year < parseInt(upToYear); year++) {
        creditCardYearOptions.push({
            value: year,
            show: year,
        })
    }
    const creditCardMonthOptions = []
    for (let month = parseInt(1); month <= parseInt(12); month++) {
        let monthValue = ('0' + month).slice(-2)
        creditCardMonthOptions.push({
            value: monthValue,
            show: monthValue,
        })
    }
    const validationCard = Yup.object({
        card_number: Yup.string()
            .min(15, 'Invalid credit card number!')
            .max(18, 'Invalid credit card number!')
            .required(t('required') + '!'),
        card_name: Yup.string()
            .trim()
            .matches(/^[a-zA-Z\s]*$/g, 'The special characters and numbers are not allowed!')
            .required(t('required') + '!'),
        card_exp_month: Yup.string().required(t('required') + '!'),
        card_exp_year: Yup.string().required(t('required') + '!'),
        card_cvc: Yup.string()
            .matches('^[0-9]{3,4}$', 'Invalid CVV!')
            .required(t('required') + '!'),
        card_address_line1: Yup.string()
            .trim()
            .required(t('required') + '!'),
        card_address_line2: Yup.string(),
        card_address_city: Yup.string()
            .trim()
            .matches(/^[a-zA-Z ]*$/g, 'Only characters allowed')
            .required(t('required') + '!'),
        card_address_state: Yup.string().required(t('required') + '!'),
        card_address_country: Yup.string().required(t('required') + '!'),
        card_address_zip: Yup.string().when('card_address_country', {
            is: '38',
            then: Yup.string()
                .required(t('required') + '!')
                .min(5, 'Minimum 5 characters')
                .max(6, 'Minimum 7 characters'),
            otherwise: Yup.string()
                .required(t('required') + '!')
                .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
                .min(5, 'Minimum 5 characters')
                .max(6, 'Minimum 7 characters'),
        }),
        // phone: Yup.string().matches(phonenumber, 'Phone number is not valid'),
    })

    const cardFormik = useFormik({
        initialValues: {
            account_id: process.env.REACT_APP_AUCTIONPAYID,
            customer_id: '',
            card_number: '',
            card_name: '',
            card_exp_month: '',
            card_exp_year: '',
            card_cvc: '',
            cvv: '',
            card_address_line1: '',
            card_address_line2: '',
            card_address_city: '',
            card_address_state: '',
            card_address_zip: '',
            card_address_country: '' || global.defaultCountry == 'US' ? 224 : '',
            is_primary: '',
            user_id: '',
            id: '',
            card_token: true,
        },
        validationSchema: validationCard,
        onSubmit: (values) => {
            // setDisabled(true)
            console.log('came to card context -')
            setLoading(true)
            var send_params = values
            var country_name
            if (send_params.card_address_country && countryList.length > 0) {
                var card_country = countryList.filter(
                    (val) => parseInt(val.location_id) == parseInt(values.card_address_country),
                )
                if (card_country.length > 0) {
                    // send_params.card_address_country = card_country[0].name;
                    country_name = card_country[0].name
                }
            }

            createStripeCard({
                ...send_params,
                country_name,
                customer_id: customerId,
                user_id: customerUserId,
            })
            return
        },
    })
    const cardDetails = {
        formik: cardFormik,
        data: [
            {
                label: t('card_holder_name'),
                type: 'text',
                placeholder: 'Enter your card holder name',
                class: 'col-12',
                name: 'card_name',
            },
            {
                label: t('card_number'),
                type: 'number',
                placeholder: 'Enter your card number',
                class: 'col-12',
                name: 'card_number',
            },
            {
                label: 'Expiration Month',
                placeholder: 'MM',
                class: 'col-6',
                type: 'select',
                name: 'card_exp_month',
                options: creditCardMonthOptions,
            },
            {
                label: 'Expiration Year',
                placeholder: 'YYYY',
                class: 'col-6',
                type: 'select',
                name: 'card_exp_year',
                options: creditCardYearOptions,
            },
            {
                label: t('cvv'),
                type: 'number',
                placeholder: 'Enter your CVV',
                class: 'col-12',
                name: 'card_cvc',
            },
            {
                label: t('address_line_1'),
                type: 'text',
                placeholder: 'Enter address line1',
                class: 'col-12',
                name: 'card_address_line1',
            },
            {
                label: t('address_line_2'),
                type: 'text',
                placeholder: 'Enter address line2',
                class: 'col-12',
                name: 'card_address_line2',
            },
            {
                label: t('city'),
                type: 'text',
                placeholder: 'Enter city',
                class: 'col-12',
                name: 'card_address_city',
            },
            // {
            //     label: 'Card address state',
            //     type: 'text',
            //     placeholder: 'Enter card address state',
            //     class: 'col-12',
            //     name: 'card_address_state',
            // },
            // {
            //     label: 'Card address country',
            //     type: 'text',
            //     placeholder: 'Enter card address country',
            //     class: 'col-12',
            //     name: 'card_address_country',
            // },
            // {
            //     label: t('country'),
            //     placeholder: t('select_country'),
            //     class: 'col-12',
            //     type: 'select',
            //     options: swapCountry(countryList).map((country) => {
            //         let busCategoryChanged = {}
            //         busCategoryChanged.show = country.name
            //         busCategoryChanged.value = country.location_id
            //         return busCategoryChanged
            //     }),
            //     name: 'card_address_country',
            // },
            {
                label: `${cardFormik.values.card_address_country == 38 ? 'Provinces' : t('state')}`,
                type: 'select',
                placeholder: `${
                    cardFormik.values.card_address_country == 38
                        ? 'Select provinces'
                        : t('select_state')
                }`,
                class: 'col-12',
                options: stateList.map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.name
                    busCategoryChanged.value = buscat.name
                    return busCategoryChanged
                }),
                name: 'card_address_state',
            },
            {
                label: `${
                    cardFormik.values.card_address_country == 38 ? 'Postal code' : t('Zip_code')
                }`,
                type: 'text',
                placeholder: `Enter ${
                    cardFormik.values.card_address_country == 38 ? 'postal code' : 'zip'
                }`,
                class: 'col-12',
                name: 'card_address_zip',
            },
        ],
    }
    useEffect(() => {
        if (user) {
            cardFormik.values.customer_id = user.card_paymentid
        }
    }, [user])
    // useEffect(() => {
    //     getLocationData(0)
    // }, [formik.values.country])
    useEffect(() => {
        getLocationData(1)
    }, [])
    useEffect(() => {
        getAlldynamic({
            site_id: global?.storeDetails?.site_id ? global.storeDetails.site_id : '',
            store_id: global?.storeDetails?.id ? global.storeDetails.id : '',
            type: 3,
        })
    }, [])

    useEffect(() => {
        if (
            saveClicked &&
            (cardFormik.values?.card_name == undefined || cardFormik.values?.card_name == '') &&
            activeStep == 3
        ) {
            window.scrollTo(0, 0)
        }
    }, [cardFormik.errors])

    useEffect(() => {
        if (global?.storeConfigration?.default_phone_code?.value) {
            var phone_code = global?.storeConfigration?.default_phone_code?.value
            if (
                formik.values.phone.length < phone_code.length ||
                !formik.values.phone.includes(phone_code)
            ) {
                formik.setFieldValue('phone', formik.values.phone_number_new)
            } else {
                formik.setFieldValue('phone_number_new', formik.values.phone)
            }
        }
    }, [formik.values.phone])

    useEffect(() => {
        console.log(dynamicproducts, 'dynamicproducts =======')
        if (formik) {
            if (dynamicproducts.length > 0) {
                if (dynamicproducts[0].form_json.includes('[{')) {
                    var data_add = data.slice(0, data.length - 2)
                    var json_temp = JSON.parse(dynamicproducts[0].form_json_temp)
                    var dynamic_fields = {}
                    JSON.parse(dynamicproducts[0].form_json).map((val, ind) => {
                        if (val.type == 'radio') {
                            // formik.values[val.name] = val.values.filter(
                            //     (v) => v.selected == 'true',
                            // )[0].value

                            var dynamic_selected_value = val.values.filter(
                                (v) => v.selected == 'true',
                            )
                            val.checked_need = 1
                            if (dynamic_selected_value.length > 0) {
                                dynamic_fields[val.name] = dynamic_selected_value[0].value
                            }
                        } else if (val.type == 'checkboxgroup') {
                            dynamic_fields[val.name] = []
                            val.values.map((kt) => {
                                if (kt.selected == 'true') {
                                    dynamic_fields[val.name].push(kt.value)
                                }
                            })
                        } else {
                            dynamic_fields[val.name] = json_temp[ind].value
                                ? json_temp[ind].value
                                : ''
                        }
                        data_add.push(val)
                    })
                    var dynamic_validation = Yup.object().shape(
                        json_temp.reduce((a, c) => {
                            let fieldSchema

                            if (c.required == 'true') {
                                if (c.type == 'text') {
                                    fieldSchema = Yup.string()
                                        .trim()
                                        .matches(
                                            /^[a-zA-Z\s]*$/g,
                                            'The special characters and numbers are not allowed!',
                                        )
                                        .max(
                                            parseInt(c.maxlength),
                                            `Maximum ${c.maxlength} characters`,
                                        )
                                        .required('Required')
                                }
                                if (c.type == 'textarea') {
                                    fieldSchema = Yup.string()
                                        .trim()
                                        .max(
                                            parseInt(c.maxlength),
                                            `Maximum ${c.maxlength} characters`,
                                        )
                                        .required('Required')
                                }
                                if (c.type == 'number') {
                                    fieldSchema = Yup.number()
                                        .typeError('Only numbers are allowed')
                                        .min(parseInt(c.min), `Minimum value is ${c.min}.`)
                                        .max(parseInt(c.max), `Maximum value is ${c.max}.`)
                                        .required('Required')
                                }
                                if (c.type == 'select') {
                                    fieldSchema = Yup.string().trim().required('Required')
                                }
                                if (c.type == 'checkbox-group') {
                                    fieldSchema = Yup.array()
                                        .min(1, 'Please select atleast one checkbox')
                                        .of(
                                            Yup.string().required(
                                                'Please select atleast one checkbox',
                                            ),
                                        )
                                        .required('Please select atleast one checkbox')
                                }
                                return { ...a, [c.name]: fieldSchema }
                            } else {
                                return a
                            }
                        }, {}),
                    )
                    setFields({
                        data: [...data_add, ...data.slice(data.length - 2)],
                        formik: formik,
                        dynamic_validation: Yup.object().shape({
                            ...validationArray.fields,
                            ...dynamic_validation.fields,
                        }),
                        dynamic_fields: dynamic_fields,
                    })
                    data = [...data_add, ...data.slice(data.length - 2)]
                } else {
                    setFields({ data: data, formik: formik })
                }
            } else {
                setFields({ formik: formik, data: data })
            }
        }
    }, [dynamicproducts, stateList, countryList, othersField])

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'register') {
                if (responseStatus.status === 'success') {
                    setActiveStep((prev) => prev + 1)
                    window.scrollTo(0, 0)
                    setLoading(false)
                    formik.setFieldValue('userid', responseStatus.data.userid)
                    setCustomerUserId(responseStatus.data.userid)
                    const securityData = {
                        user_id: responseStatus.data.userid,
                        last_4: '',
                        first_name: formik.values.first_name,
                        last_name: formik.values.last_name,
                        email: formik.values.email,
                        address: formik.values.address1,
                        city: formik.values.city,
                        state: formik.values.state,
                        country: formik.values.country,
                        zipcode: formik.values.zip,
                        email_service: formik.values.email,
                        type: '1',
                    }
                    securityScanner(securityData, 'register')
                    // if (formik.values.subscribe) {
                    //     const data = {
                    //         EMAIL: formik.values.email,
                    //     }
                    //     jsonp(
                    //         `//${
                    //             global.storeConfigration?.subscribe_code.value
                    //         }${queryString.stringify(data)}`,
                    //         { param: 'c' },
                    //         (err, data) => {
                    //             ////console.log('display', data.result)
                    //             if (err) {
                    //                 //console.log('display', err)
                    //             }
                    //             // if (data.result === 'success') {
                    //             //     setAlert(data.msg, 'success')
                    //             // }
                    //             if (data.result === 'error') {
                    //                 setAlert(data.msg, 'warning')
                    //             }
                    //         },
                    //     )
                    // }
                    if (
                        searchParams.get('ref') &&
                        global.pluginConfiguration?.referral?.enable == 1
                    ) {
                        createReferral({
                            user_id: responseStatus.data.userid,
                            site_id: global?.storeDetails?.site_id,
                            email1: formik.values.email,
                            email2: atob(searchParams.getAll('ref')),
                            to_id: responseStatus.data.userid,
                            name: `${formik.values.first_name} ${formik.values.last_name}`,
                            source: 'Registered',
                        })
                    }
                    clearResponse()
                    // if (searchParams.get('auction_id')) {
                    //     handleRedirectInternal(
                    //         history,
                    //         'login?auction_id=' + searchParams.get('auction_id'),
                    //     )
                    // } else {
                    //     handleRedirectInternal(history, 'login')
                    // }
                }
                setLoading(false)
            }

            if (responseStatus.from === 'verify_user_mail_phone') {
                console.log('response status --', responseStatus)
                if (
                    responseStatus.data?.messages?.length ||
                    responseStatus.data?.result?.length > 0
                ) {
                    console.log('response status --', responseStatus)
                    if (activeStep == 0) {
                        setActiveStep((prev) => prev + 1)
                        window.scrollTo(0, 0)
                    }
                    if (activeStep == 2) {
                        setMobileVerification(true)
                    }
                    setLoading(false)
                    if (!responseStatus.data?.messages?.length) {
                        responseStatus.data.messages = responseStatus.data.result
                    }
                    // setOtppopup(true)
                    responseStatus.data.messages.map((val) => {
                        if (val.status_text == 'Verification code sent to your mobile number') {
                            var decipher = sha256.createDecipher(
                                'aes-256-ctr',
                                '!@#$Auction_Software_9089',
                            )
                            var dec = decipher.update(val.encrypt_sms_code, 'hex', 'utf8')
                            dec += decipher.final('utf8')

                            setMobileotp(dec)
                        }
                        if (val.status_text == 'Verification code sent to your email') {
                            var decipher = sha256.createDecipher(
                                'aes-256-ctr',
                                '!@#$Auction_Software_9089',
                            )
                            var dec = decipher.update(val.encrypt_sms_code, 'hex', 'utf8')
                            dec += decipher.final('utf8')

                            setEmailotp(dec)
                        }
                    })
                    // setAlert('Verification Code Sent Successfully!', 'success')
                }
                setLoading(false)
            }
        }
    }, [responseStatus])

    useEffect(() => {
        if (regpro && isAuthenticated) {
            var role = regpro.location.search.split('=')[1]
            formik.values.role = role
        }
        if (isAuthenticated) {
            logout()
        }
    }, [regpro])
    useEffect(() => {
        if (stripeCardResponse) {
            if (stripeCardResponse.from === 'card_source_create') {
                if (stripeCardResponse.status === 'success') {
                    setActiveStep((prev) => prev + 1)
                    setLoading(false)

                    securityScanner(
                        {
                            user_id: user?.id,
                            first_name: user?.first_name,
                            last_name: user?.last_name,
                            email: user?.email,
                            address: cardFormik.values.card_address_line1,
                            city: cardFormik.values.card_address_city,
                            state: cardFormik.values.card_address_state,
                            country: cardFormik.values.card_address_country,
                            zipcode: cardFormik.values.card_address_zip,
                            type: 3,
                            last_4: cardFormik.values.card_number.toString().slice(-4),
                        },
                        'register',
                    )
                    //Set the default cardwhile registering

                    updateCustomerDefaultCard({
                        userid: formik?.values?.userid,
                        customerProfileId: stripeCardResponse?.data?.id,
                    })
                    buyerNotification({ content: 'Buyer Add Credit Card!' })
                    cardFormik.resetForm()
                } else {
                    setLoading(false)
                }
            }
            if (stripeCardResponse.from === 'card_source_update') {
                if (stripeCardResponse.status === 'success') {
                    buyerNotification({ content: 'Buyer Update Credit Card!' })
                }
            }
            if (stripeCardResponse.from === 'card_source_delete') {
                if (stripeCardResponse.status === 'success') {
                    buyerNotification({ content: 'Buyer Delete Credit Card!' })
                }
            }
            // setDisabled(false)
            // props.loader && setIsLoading(false)
            stripeCardClearResponse()
        }
    }, [stripeCardResponse])

    useEffect(() => {
        if (activeStep == 3) {
            createStripeCustomer({
                account_id: process.env.REACT_APP_AUCTIONPAYID,
                description: 'TEST CUSTOMER',
                email: formik.values.email,
                name: formik.values.first_name + ' ' + formik.values.last_name,
            })
        }
    }, [activeStep])

    useEffect(() => {
        if (responseStatusStripeCustomer) {
            if (responseStatusStripeCustomer.status === 'success') {
                if (responseStatusStripeCustomer.from === 'create') {
                    addCustomerProfile({
                        customer_id: responseStatusStripeCustomer.data.id,
                        userid: formik.values.userid,
                    })
                    setCustomerId(responseStatusStripeCustomer.data.id)
                }

                setLoading(false)
            }
        }
    }, [responseStatusStripeCustomer])

    const call_register = () => {
        register(reg_req_data)
    }

    const verifyvalidationArray = Yup.object({
        smscode:
            global?.storeConfigration?.otp_verification_mobile_number?.value == 1
                ? Yup.string()
                      .trim()
                      .matches(/^[0-9a-zA-Z- ,.#()]*$/g, 'Special characters not allowed')
                      .max(4, 'Maximum 4 digits')
                      .required('Required')
                : '',
        emailcode:
            global?.storeConfigration?.otp_verification_email?.value == 1
                ? Yup.string()
                      .trim()
                      .matches(/^[0-9a-zA-Z- ,.#()]*$/g, 'Special characters not allowed')
                      .max(4, 'Maximum 4 digits')
                      .required('Required')
                : '',
    })

    const verifyformik = useFormik({
        initialValues: { smscode: '', emailcode: '' },
        validationSchema: verifyvalidationArray,
        onSubmit: async (values) => {
            call_verify_and_register()
        },
    })

    const verifypopup = [
        {
            label: 'SMS Code',
            name: 'smscode',
            type: 'number',
            placeholder: 'Enter your sms code',
            class:
                global?.storeConfigration?.signup_page_changes?.value == '1' &&
                global?.storeConfigration?.otp_verification_mobile_number?.value == 1
                    ? ''
                    : global?.storeConfigration?.otp_verification_mobile_number?.value == 1
                    ? ''
                    : 'd-none',
            formik: verifyformik,
        },
        {
            label: 'Email Code',
            name: 'emailcode',
            type: 'number',
            placeholder: 'Enter your email code',
            class: global?.storeConfigration?.otp_verification_email?.value == 1 ? '' : 'd-none',
            formik: verifyformik,
        },
    ]

    const setstatefrommap = () => {
        if (formik.values.tempAddress.split(',').length > 3) {
            let newAdd = formik.values.tempAddress.split(',')
            let addLength = newAdd.length
            //console.log('newAdd state', newAdd, addLength)
            let findValue = newAdd[addLength - 2].trim()
            let newState = stateList.findIndex(
                (e) => e.map_code_io == findValue || e.name == findValue,
            )
            if (newState != -1) {
                formik.setFieldValue('state', stateList[newState].name)
            } else {
                formik.setFieldValue('state', '')
            }

            let findcity = newAdd[addLength - 3].trim()
            formik.setFieldValue('city', findcity)
        } else {
            formik.setFieldValue('state', '')
            formik.setFieldValue('city', '')
        }
    }

    useEffect(() => {
        if (formik.values.tempAddress != '' && global.storeConfigration?.map_input?.value == '1') {
            if (formik.values.tempAddress.split(',').length > 3) {
                formik.values.address1 = formik.values.tempAddress
                let newAdd = formik.values.tempAddress.split(',')
                let addLength = newAdd.length
                //console.log('newAdd', newAdd, addLength)
                let findValue =
                    newAdd[addLength - 1].trim() == 'USA'
                        ? 'United States'
                        : newAdd[addLength - 1].trim() == 'UK'
                        ? 'United Kingdom'
                        : newAdd[addLength - 1].trim()
                let newCountry = countryList.findIndex((e) => e.name == findValue)
                if (newCountry > 0) {
                    if (formik.values.country != countryList[newCountry].location_id) {
                        formik.setFieldValue('country', countryList[newCountry].location_id)
                    } else {
                        setstatefrommap()
                    }
                } else {
                    formik.setFieldValue('country', '')
                }
            }
        }
    }, [formik.values.tempAddress])

    useEffect(() => {
        if (formik.values.tempAddress != '' && global.storeConfigration?.map_input?.value == '1') {
            setstatefrommap()
        }
    }, [stateList])

    useEffect(() => {
        if (formik.values.referral == 10) {
            setOtherField(true)
        } else {
            setOtherField(false)
        }
    }, [formik.values.referral])

    // Select the contents on focus
    function handleFocus(e) {
        e.target.select()
    }

    function handleChange(e, index) {
        const value = e.target.value.replace(/\D/, '') // only digits
        if (!value) return

        const codeArr = formik.values.verification_code.split('')
        codeArr[index] = value
        const newCode = codeArr.join('').padEnd(6, '')

        formik.setFieldValue('verification_code', newCode)

        if (value && inputRefs.current[index + 1]) {
            inputRefs.current[index + 1].focus()
        }
    }

    function handleChange2(e, index) {
        const value = e.target.value.replace(/\D/, '') // only digits
        if (!value) return

        const codeArr = formik.values.verification_mobile_code.split('')
        codeArr[index] = value
        const newCode = codeArr.join('').padEnd(4, '')

        formik.setFieldValue('verification_mobile_code', newCode)

        if (value && inputRefs.current[index + 1]) {
            inputRefs.current[index + 1].focus()
        }
    }

    function handleKeyDown(e, index) {
        if ((e.key === 'Backspace' || e.key === 'Delete') && !e.target.value) {
            const codeArr = formik.values.verification_code.split('')
            codeArr[index] = ''
            const newCode = codeArr.join('').padEnd(6, '')
            formik.setFieldValue('verification_code', newCode)

            if (inputRefs.current[index - 1]) {
                inputRefs.current[index - 1].focus()
            }
        }
    }

    function handleKeyDown2(e, index) {
        if ((e.key === 'Backspace' || e.key === 'Delete') && !e.target.value) {
            const codeArr = formik.values.verification_mobile_code.split('')
            codeArr[index] = ''
            const newCode = codeArr.join('').padEnd(4, '')
            formik.setFieldValue('verification_mobile_code', newCode)

            if (inputRefs.current[index - 1]) {
                inputRefs.current[index - 1].focus()
            }
        }
    }
    const handlePaste = (e, limit) => {
        const paste = e.clipboardData.getData('text')
        const digits = paste.replace(/\D/g, '').slice(0, limit)

        if (digits.length === 0) return

        e.preventDefault()

        digits.split('').forEach((digit, idx) => {
            if (inputRefs.current[idx]) {
                inputRefs.current[idx].value = digit

                // Optional: move focus to next input
                if (idx < inputRefs.current.length - 1) {
                    inputRefs.current[idx + 1]?.focus()
                }
            }
        })
        formik.setFieldValue('verification_code', digits)
    }
    console.log('formik errors -', formik.errors)
    return (
        <>
            <form className="reg-step1" onSubmit={formik.handleSubmit}>
                {activeStep !== 4 && (
                    <div className="stepperContainer">
                        <Stepper activeStep={activeStep}>
                            {steps.map((label, index) => (
                                <Step
                                    key={label}
                                    className={index + 1 == activeStep ? 'MuiStep-activetab' : ''}
                                >
                                    <StepButton
                                        onClick={() => handleStep(index)}
                                        completed={completed[index]}
                                    />
                                </Step>
                            ))}
                        </Stepper>
                    </div>
                )}
                {title && (
                    <h1>
                        {activeStep == 0
                            ? title
                            : activeStep == 1
                            ? 'Check Your Email'
                            : activeStep == 2
                            ? "Verify it's you"
                            : activeStep == 3
                            ? 'Add a Payment Method'
                            : ''}
                    </h1>
                )}
                {activeStep == 0 ? (
                    <>
                        <h4>
                            Already have an account? <Link to="/login"> Sign in</Link>
                        </h4>
                        <div className="row">
                            {Object.keys(fields).length > 0
                                ? mapData({ formik: formik, data: fields.data })
                                : mapData(registerInfo)}
                        </div>
                        <div className="signupBtn">
                            <PrimaryButton
                                label="Submit"
                                disabled={loading}
                                type="submit"
                                // onClick={handleStep}
                            />
                        </div>
                        <div className="row">{mapData(promotionData)}</div>
                        <p className="termsPvy">
                            By continuing , you agree to our{' '}
                            {/* <a
                                href={`https://liquidityservices.com/privacy-policy`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Terms of Use
                            </a>{' '} */}
                            <a href="/conditions" target="_blank" rel="noopener noreferrer">
                                Terms of Use
                            </a>{' '}
                            and{' '}
                            <a href={`/privacy_policy`} target="_blank" rel="noopener noreferrer">
                                Privacy Policy
                            </a>
                        </p>
                    </>
                ) : activeStep == 1 ? (
                    <div className="">
                        <h4>
                            We&apos;ve sent you an email with a verification code.{' '}
                            <button
                                type="button"
                                onClick={() =>
                                    verifyemailandsmscode({
                                        ...formik.values,
                                        six_digit: 1,
                                        exclude_phone: 1,
                                    })
                                }
                            >
                                Re-send
                            </button>
                        </h4>

                        <div className="verifyMainMultiField">
                            {[0, 1, 2, 3, 4, 5].map((index, i) => (
                                <input
                                    className="text-2xl bg-gray-800 w-10 flex p-2 text-center"
                                    key={i}
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    type="text"
                                    maxLength={1}
                                    onChange={(e) => handleChange(e, index)}
                                    // ref={inputRefs[index]}
                                    // autoFocus={index === 0}
                                    onFocus={handleFocus}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    onPaste={(e) => handlePaste(e, 6)}
                                    // disabled={isLoading}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                />
                            ))}
                        </div>
                        {formik.touched.verification_code && formik.errors.verification_code && (
                            <p className="text-red-500 text-sm mt-2 text-danger">
                                {formik.errors.verification_code}
                            </p>
                        )}
                        <div className="signupBtn">
                            <PrimaryButton label="Continue" disabled={loading} type="submit" />
                        </div>
                    </div>
                ) : activeStep == 2 ? (
                    <>
                        <h4>To protect the bidding process, please verify your phone number</h4>
                        {!mobileVerification ? (
                            <div className="row">{mapData(verifyPhoneInfo)}</div>
                        ) : (
                            <>
                                <div className="verifyMainMultiField">
                                    {[0, 1, 2, 3].map((index, i) => (
                                        <input
                                            className="text-2xl bg-gray-800 w-10 flex p-2 text-center"
                                            key={i}
                                            ref={(el) => (inputRefs.current[index] = el)}
                                            type="text"
                                            maxLength={1}
                                            onChange={(e) => handleChange2(e, index)}
                                            // ref={inputRefs[index]}
                                            // autoFocus={index === 0}
                                            onFocus={handleFocus}
                                            onKeyDown={(e) => handleKeyDown2(e, index)}
                                            onPaste={(e) => handlePaste(e, 4)}
                                            // disabled={isLoading}
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                        />
                                    ))}
                                </div>
                                {skipValidation
                                    ? formik.touched.verification_mobile_code &&
                                      formik.errors.verification_mobile_code && (
                                          <p className="text-red-500 text-sm mt-2">
                                              {formik.errors.verification_mobile_code}
                                          </p>
                                      )
                                    : ''}
                            </>
                        )}
                        <div className="signupBtn">
                            <PrimaryButton label="Submit" disabled={loading} type="submit" />
                        </div>
                        <small className="smalltxt mb-3">
                            <i>
                                *We may send you important account updates via SMS message. You may
                                opt-out any time.
                            </i>
                        </small>
                        <button
                            className="maybeLater"
                            type="submit"
                            disabled={loading}
                            onClick={() => {
                                setSkipValidation(true)
                                setLoading(false)
                            }}
                        >
                            Maybe Later &gt;
                        </button>
                    </>
                ) : activeStep == 3 ? (
                    <>
                        <small className="smalltxt">
                            <i>
                                In order to bid on auctions, you need to add a payment method. All
                                bids and purchases are final.
                            </i>
                        </small>
                        <small className="smalltxt">
                            <i>
                                <b>
                                    This will be set as your primary card. You won&apos;t be charged
                                    until you win an item.
                                </b>
                            </i>
                        </small>
                        {/* <form onSubmit={cardFormik.handleSubmit} autoComplete="nofill"> */}
                        <div className="row mt-3">{mapData(cardDetails)}</div>
                        <div className="row">
                            <div className="col-12 paymentMethBtns">
                                <PrimaryButton
                                    disabled={loading}
                                    btnSize="large"
                                    onClick={() => {
                                        setSaveClicked(true)
                                        window.scrollTo(0, 0)
                                        cardFormik.handleSubmit()
                                    }}
                                    label="Save"
                                />
                            </div>
                        </div>
                        {/* </form> */}
                        <small className="smalltxt">
                            <i>
                                *Your information is protected with industry-leading encryption to
                                ensure your data stays safe.
                            </i>
                        </small>
                        <button
                            className="maybeLater"
                            type="submit"
                            disabled={loading}
                            onClick={() => {
                                setSkipValidation(true)
                                window.scrollTo(0, 0)
                                setLoading(false)
                            }}
                        >
                            Maybe Later &gt;
                        </button>
                    </>
                ) : (
                    <>
                        <div className="registerSuccessfully">
                            <div className="">
                                <object
                                    data="/lots-images/greenField/Vector/successcheck.svg"
                                    type="image/svg+xml"
                                    width="300"
                                    height="200"
                                >
                                    Your browser does not support SVGs.
                                </object>
                                <h4 className="susessText">Success</h4>
                                <p className="gretingText">
                                    Congratulations! Your account has been created.
                                </p>
                                <PrimaryButton label="Start browsing" type="submit" />
                            </div>
                        </div>
                    </>
                )}
            </form>

            {/* <form className="reg-step1" onSubmit={formik.handleSubmit}>
                {title && <h1>{title}</h1>}
                {subTitle && <h4>{subTitle}</h4>}
                <div className="row">
                    {Object.keys(fields).length > 0
                        ? mapData({ formik: formik, data: fields.data })
                        : mapData(registerInfo)}
                </div>
                <div className="text-center form-group">
                    {captcha && <Captch formik={formik} name="captch" />}
                    <PrimaryButton label="Submit" disabled={loading} type="submit" />
                    {global.pluginConfiguration?.login_with_facebook?.enable == 1 ? (
                        <div className="mt-3">
                            <FacebookLogin
                                appId={global.pluginConfiguration?.login_with_facebook?.client_key}
                                fields="name,email,picture"
                                // onClick={componentClicked}
                                callback={responseFacebook}
                                textButton="Signup With Facebook"
                                size="medium"
                            />
                        </div>
                    ) : null}
                    {global.pluginConfiguration?.login_with_google?.enable == 1 ? (
                        <GoogleOAuthProvider
                            clientId={global.pluginConfiguration?.login_with_google?.client_key}
                            width={isDesktop ? '450px' : '300px'}
                        >
                            <div className="mt-3 googleLogin">
                                <GoogleLogin
                                    onSuccess={(credentialResponse) => {
                                        responseGoogle(credentialResponse)
                                    }}
                                    shape="rectangular"
                                    size="large"
                                    width={isDesktop ? '450px' : '300px'}
                                    onError={() => {
                                        console.log('Login Failed')
                                    }}
                                    text="signup_with"
                                />
                            </div>
                        </GoogleOAuthProvider>
                    ) : null}
                    <div className="newAcc mt-3 text-center">
                        <p>
                            Already have an account ?{' '}
                            <Link
                                to="/login"
                                className={`${
                                    global.storeDetails.id === 41 && 'full-basket-login'
                                }`}
                            >
                                Login here
                            </Link>
                        </p>
                    </div>
                </div>
            </form> */}

            <Popup
                open={terms_condition}
                size="md"
                className="save-search-modal"
                modaltitle="Terms and Condition"
                handleClose={() => setTermscondition(false)}
            >
                {' '}
                <div className="px-5 py-4 stctPgWrpr">
                    {/* <h2>About Us</h2> */}
                    <span
                        dangerouslySetInnerHTML={{
                            __html: global?.storeDetails?.terms_condition
                                ? global.storeDetails.terms_condition
                                : '',
                        }}
                    ></span>
                </div>
                <div className="row">
                    <div className="col-4"></div>
                    <div className="col-3">
                        <PrimaryButton
                            onClick={(e) => call_register()}
                            btnSize="mt-3"
                            label="Agree & Submit"
                            type="submit"
                        />
                    </div>
                </div>
            </Popup>

            <Popup
                open={otppopup}
                size="xl"
                modalClass="save-search-modal"
                modaltitle="Verification"
                handleClose={() => setOtppopup(false)}
            >
                {' '}
                <div className="stctPgWrpr">
                    <div style={{ maxWidth: '400px', margin: 'auto' }}>{mapData(verifypopup)}</div>
                </div>
                <div style={{ maxWidth: 'fit-content', margin: 'auto' }}>
                    <div>
                        <PrimaryButton
                            onClick={verifyformik.handleSubmit}
                            btnSize="mt-3"
                            label="Submit"
                            type="submit"
                        />
                    </div>
                </div>
            </Popup>
        </>
    )
}

export default SignupStepperFunction
